import { BavelRenovatingPopoupComponent } from '@shared/components/bavel-renovating-popup/bavel-renovating-popoup.component';
import { BavelSharedModule } from "@shared/shared.module";
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { PopoverModule } from 'primeng/popover';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ServerInfoService } from './services/server-info.service';
import { ToolFooterComponent } from './components/main/components/footer/tool-footer.component';
import { ToolMainComponent } from './components/main/tool-main.component';
import { ToolMenuComponent } from './components/main/components/menu/tool-menu.component';
import { TooltipModule } from 'primeng/tooltip';
import { ToolTopbarComponent } from './components/main/components/topbar/tool-topbar.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    BavelRenovatingPopoupComponent,
    ToolFooterComponent,
    ToolMainComponent,
    ToolMenuComponent,
    ToolTopbarComponent
  ],
  imports: [
    BavelSharedModule,
    CheckboxModule,
    CommonModule,
    DialogModule,
    FormsModule,
    PopoverModule,
    RouterModule.forChild([]),
    TooltipModule,
    TranslateModule,
  ],
  providers: [
    ServerInfoService,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class BavelToolModule { }
